import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: theme.palette.secondary[50],
            borderWidth: 1,
            borderStyle: 'solid',
            borderLeftWidth: 0,
            borderBottomWidth: 0,
            borderColor: theme.palette.secondary[300],
            borderTopRightRadius: theme.spacing(0.5),
            height: theme.spacing(4.5),
            minHeight: `${theme.spacing(4.5)} !important`,
        },
    }
})

export default useStyles
